<template>
  <v-badge v-if="badgeValue" class="toggle-chip" :content="badgeValue" overlap>
    <v-chip @click="toggleValue" :small="small">
      <v-avatar left>
        <v-icon :small="small">{{ icon }}</v-icon>
      </v-avatar>
      <slot></slot>
    </v-chip>
  </v-badge>
  <v-chip v-else @click="toggleValue" class="toggle-chip" :small="small">
    <v-avatar left>
      <v-icon :small="small">{{ icon }}</v-icon>
    </v-avatar>
    <slot></slot>
  </v-chip>
</template>

<script>
/**
 * Utility component for a toggleable v-chip. Has an optional badge.
 */
export default {
  name: 'ToggleChip',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    badgeValue: {
      type: [String, Number],
      default: null
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleValue () {
      this.$emit('input', !this.value)
    }
  },
  computed: {
    icon () {
      return this.value ? 'mdi-check-circle' : 'mdi-circle-outline'
    }
  }
}
</script>

<style scoped>

</style>
